import { internal } from '@xingternal/hops-bootstrap';

export default internal.getConfig();
